<template>
  <div id="template_tag" class="flex items-center gap-2">
    <span>{{ name }}</span>
    <div v-if="showTag" class="common_detail_bg_container flex flex-row px-2">
      <span class="text-[13px]">{{ tagText }}</span>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  showTag: {
    type: Boolean,
    default: false,
  },
  tagText: {
    type: String,
    default: "Primary",
  },
});
</script>

